import * as React from "react";
import { cn } from "@gettactic/helpers";

interface SpoilerProps {
  maxHeight: number;
  showLabel?: React.ReactNode;
  hideLabel?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

const Spoiler = React.forwardRef<HTMLDivElement, SpoilerProps>(
  (
    {
      maxHeight,
      showLabel = "Show more",
      hideLabel = "Show less",
      children,
      className
    },
    ref
  ) => {
    const [expanded, setExpanded] = React.useState(false);
    const [shouldShowButton, setShouldShowButton] = React.useState(false);
    const contentRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
      if (contentRef.current) {
        setShouldShowButton(contentRef.current.scrollHeight > maxHeight);
      }
    }, [maxHeight, children]);

    return (
      <div ref={ref} className={cn("relative", className)}>
        <div
          ref={contentRef}
          className="overflow-hidden transition-all duration-200"
          style={{
            maxHeight: expanded ? contentRef.current?.scrollHeight : maxHeight
          }}
        >
          {children}
        </div>
        {shouldShowButton && (
          <button
            type="button"
            onClick={() => setExpanded(!expanded)}
            className="mt-1 text-sm font-medium text-primary hover:underline"
          >
            {expanded ? hideLabel : showLabel}
          </button>
        )}
      </div>
    );
  }
);
Spoiler.displayName = "Spoiler";

export { Spoiler };
export type { SpoilerProps };
